import { Model, model, modelAction, prop } from "mobx-keystone";
import KeystoneDataStore from '../../../core/store/keystone';
import { randomString } from '../../../core/utils';

import seeds from './seed';


type ResourceData = {
    behavior?: string;
    href?: string;
    title: string;
    body: string;
    image: string;
    icon?: string;
    subtitle: string;
};

type StringMap = {
    [key: string]: string;
};


@model("rfe/ContentStore")
export class ContentStore extends Model({
    menu: prop<Anchor[]>(() => []),
    resources: prop<Resource[]>(() => []),
    terms: prop<StringMap>(() => ({})),
}) {

    term(key: string) {
        return this.terms[key] || '';
    }

    @modelAction
    setTerm(key: string, value: string) {
        this.terms = { ...this.terms, [key]: value };
    }

    @modelAction
    addMenuAnchor(href: string, text: string) {
        const a = new Anchor({ text, href });
        this.menu.push(a);
    }

    @modelAction
    addResource(data: ResourceData) {
        this.resources.push(new Resource(data));
    }
    
    @modelAction
    clear() {
        this.terms = {};
        this.menu = [];
        this.resources = [];
    }
}

@model("rfe/Anchor")
export class Anchor extends Model({
    href: prop<string>(),
    text: prop<string>(),
}) {
    @modelAction
    setText(text: string) {
        this.text = text;
    }
}

@model('rfe/Resource')
export class Resource extends Model({
    title: prop<string>(),
    subtitle: prop<string>(),
    body: prop<string>(),
    image: prop<string>(),
    behavior: prop<string>('modal'),
    icon: prop<string>('map'),
    href: prop<string>(() => randomString(12)),
}) {
    @modelAction
    setTitle(title: string) {
        this.title = title;
    }

    @modelAction
    setSubtitle(subtitle: string) {
        this.subtitle = subtitle;
    }

    @modelAction
    setBody(body: string) {
        this.body = body;
    }

    @modelAction
    setImage(image: string) {
        this.image = image;
    }

    @modelAction
    setBehavior(behavior: string) {
        if (this.behavior !== behavior) {
            this.setHref(behavior === 'modal' ? randomString(12) : '');
            this.behavior = behavior;
        }
    }

    @modelAction
    setHref(href: string) {
        this.href = href;
    }
}


export default new KeystoneDataStore<ContentStore>(ContentStore, seeds);
